<script>
    import { navigate } from 'svelte-routing';
    import { queryLinkedItems } from '../stores/helpers';
    import Item from './Item/index.svelte';
    export let index;
    export let item;
    export let filterAwaySource;
    export let handleManageItemAction;
    export let handleFilterAction;
    let linkedItemCount = 0;

    $: ({ linkedItemCount } = queryLinkedItems(item));

    const handleClick = (event) => {
        navigate(`/i/${item.id}`);
    }

</script>

<div class="item-container" 
    style="margin-bottom: {linkedItemCount*10 + 20}px"
    on:click="{handleClick}"
>
    <Item
        index={index}
        item={item}
        filterAwaySource={filterAwaySource}
        handleManageItemAction={handleManageItemAction}
        handleFilterAction={handleFilterAction}
    />
    {#each Array(linkedItemCount) as _, index (index)}
        <div class="feed-item" 
            style="
            transform: translate({10*index+10}px, {10*index+10}px); 
            z-index: {-1-(index+1)}
            ">
        </div>
    {/each}
</div>

<style>
    .item-container {
        position: relative;
    }
    .feed-item {
        left: 0px;
        position: absolute;
        top: 0px;

        /* Take full size */
        height: 100%;
        width: 100%;

        /* Displayed under the container */
        z-index: -1;

        /* Background and border colors */
        /* background-color: rgb(255, 255, 255); */
        background-color:rgb(5,5,5);
        border: 2px solid rgba(150, 150, 150, 0.3);
        border-radius: 4px;

        /* Rotate it. Change the number of degrees for the following cards */
        /* transform: rotate(5deg); */
    }
    /* .feed-item:nth-child(n) {
        transform: rotate(5*n)
    } */
    /* @media (max-width: 640px) {
        .feed-item {
            width: 85%;
        }
    } */
</style>